import { useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CODE_GAMEPAD_URL } from '~/config/endpoints.config';

import { SignIn, SignUp, ForgotPassword } from '~/pages/Auth';
import { OnboardingLink } from '~/pages/Onboarding';
import { HomeDemo } from '~/pages/Home/Home';
import { GamepadAccess } from '~/pages/GamepadAccess';
import { DualScreenDevPage, RegieDevPage } from '~/pages/Animator/regie/RegiePage';
import { RewardPage } from '~/pages/Reward/RewardPage';
import { OtherTab } from '~/pages/OtherTab';
import DebugFreePlay from '~/pages/DebugFreePlay/DebugFreePlay';

import GamepadApp from '~/unboared/GamepadApp';
import ScreenApp from '~/unboared/ScreenApp';

import { rememberPostLoginRedirect } from './postLoginRedirect';

/**
 * Lien profond ouvert HORS connexion (cockpit `/animator/...` scanné, email de
 * relance `/app/<clientID>?game=X`, lien `/account/cancel`) : le catch-all
 * d'AuthRoutes renvoie vers /signin en jetant l'URL demandée → après login on
 * atterrissait sur /home. On mémorise donc la destination avant le login ;
 * MainRoutes la restaure une fois connecté. Liste blanche et garde-fous dans
 * `postLoginRedirect.ts` (un login normal ne mémorise rien).
 */
function CapturePostLoginRedirect() {
    // useState initializer : exécuté exactement une fois, avant le <Navigate>.
    // Ne jette jamais (stockage indisponible → rien mémorisé, comportement d'avant).
    useState(() => {
        rememberPostLoginRedirect(window.location);
        return null;
    });
    return <Navigate to="/" replace />;
}

export function AuthRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to="/signin" />} />
                <Route path="login" element={<Navigate to="/signin" />} />
                <Route path="signin" element={<SignIn />} />
                <Route path="forgotPassword" element={<ForgotPassword />} />
                <Route path="signup" element={<SignUp />} />
                <Route path="link" element={<OnboardingLink />} />
                <Route path="app/demo" element={<ScreenApp />} />
                {/* Écran démo mis en veille (ouvert dans un autre onglet) : pas de détour par le login. */}
                <Route path="other-tab" element={<OtherTab />} />
                <Route path="demo" element={<HomeDemo />} />
                <Route path={`${CODE_GAMEPAD_URL}`} element={<GamepadAccess />} />
                <Route path={`${CODE_GAMEPAD_URL}/:sessionID`} element={<GamepadApp />} />
                <Route path="reward/:couponId" element={<RewardPage />} />
                <Route path="debug/free-play" element={<DebugFreePlay />} />
                {/* Régie double écran testée en local sans compte (jamais dans le build de prod). */}
                {import.meta.env.DEV && <Route path="dev/regie/:clientID" element={<RegieDevPage />} />}
                {import.meta.env.DEV && <Route path="dev/double-ecran/:clientID" element={<DualScreenDevPage />} />}
                <Route path="*" element={<CapturePostLoginRedirect />} />
            </Routes>
        </BrowserRouter>
    );
}
